import { getTranslation } from '@utils';
import { getUniqueDataCategories } from '@utils/general';

export const UNGROUPED_KEY = '__OTHER__';

// Counts unique data categories across every purpose in the group.
export const getGroupDataCategoryCount = (purposes = []) => {
  const seen = new Set();
  purposes.forEach((profilePurpose) => {
    getUniqueDataCategories(profilePurpose.processingActivities || []).forEach((dc) => {
      if (dc?.id) seen.add(dc.id);
    });
  });
  return seen.size;
};

// Buckets profilePurposes by `purposeGroup.id`. Anything missing a group lands
// in the "Other Purposes" bucket; group order follows first-seen order so the
// rendering matches the controller-side arrangement.
export const groupPurposes = (profilePurposes = []) => {
  const order = [];
  const map = new Map();
  profilePurposes.forEach((profilePurpose) => {
    const groupId = profilePurpose?.purposeGroup?.id || UNGROUPED_KEY;
    if (!map.has(groupId)) {
      const isUngrouped = !profilePurpose?.purposeGroup?.id;
      order.push(groupId);
      map.set(groupId, {
        id: groupId,
        isUngrouped,
        name: profilePurpose?.purposeGroup?.name || getTranslation('OTHER_PURPOSES_LABEL'),
        description: isUngrouped
          ? getTranslation('OTHER_PURPOSES_DESCRIPTION')
          : (profilePurpose?.purposeGroup?.description || ''),
        purposes: [],
      });
    }
    map.get(groupId).purposes.push(profilePurpose);
  });
  return order.map((groupId) => map.get(groupId));
};
